import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../App";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  let location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;
